import { ApplicationName as ApiApplicationName, Authority as ApiAuthority } from './ApiSettings';

export const Authority = ApiAuthority;
export const ApplicationName = ApiApplicationName;

export const QueryParameterNames = {
  ReturnUrl: 'returnUrl',
  Message: 'message',
};

export const LogoutActions = {
  LogoutCallback: 'logout-callback',
  Logout: 'logout',
};

export const LoginActions = {
  Login: 'login',
  LoginCallback: 'login-callback',
  LoginFailed: 'login-failed',
  Profile: 'profile',
  Register: 'register',
};

const prefix = '/authentication';

export const ApplicationPaths = {
  DefaultLoginRedirectPath: '/',
  ApiAuthorizationClientConfigurationUrl: `${Authority}/_configuration/${ApplicationName}`,
  AuthorizationPrefix: prefix,
  Login: `${prefix}/${LoginActions.Login}`,
  LoginFailed: `${prefix}/${LoginActions.LoginFailed}`,
  LoginCallback: `${prefix}/${LoginActions.LoginCallback}`,
  Register: `${prefix}/${LoginActions.Register}`,
  Profile: `${prefix}/${LoginActions.Profile}`,
  LogOut: `${prefix}/${LogoutActions.Logout}`,
  LogOutCallback: `${prefix}/${LogoutActions.LogoutCallback}`,
  IdentityRegisterPath: '/Identity/Account/Register',
  IdentityManagePath: '/Identity/Account/Manage',
};

export const AuthIdentityRoles = {
  SuperAdmin: 'SuperAdmin',
  ApplicationUser: 'ApplicationUser',
  TenantAdministrator: 'TenantAdministrator',
  KioskUser: 'KioskUser',
  Reservations: 'Reservations',
  VerificationManager: 'VerificationManager',
};

// noinspection HttpUrlsUsage
export const ClaimTypeRole = 'http://schemas.microsoft.com/ws/2008/06/identity/claims/role'; // NOSONAR
